import { Typography } from "@circle-react-uikit/Typography";

import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

import type { MemberEntry } from "./types";

export const MemberCell = ({ row }: { row: { original: MemberEntry } }) => {
  const { name, email, avatarUrl } = row.original;
  return (
    <div className="flex items-center gap-2">
      <UserImage name={name} src={avatarUrl} size="6" />
      <div className="flex flex-col">
        <Typography.LabelSm weight="semibold">{name}</Typography.LabelSm>
        {email && (
          <Typography.LabelXs weight="regular">{email}</Typography.LabelXs>
        )}
      </div>
    </div>
  );
};
